import { UnitConverterBase } from "./unit-converter.base";

export class UnitConverter extends UnitConverterBase {

}
